export const FETCH_TRANSLATED_UGC_URL = '/listings/fetch_translated_ugc';
